import React, { Component } from "react";
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import { Row, Col, Modal, Button } from 'antd';
import axios from '../../utils/request';


export class SanQiHuYuWrittenResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            commonParamater: null,
            tenantId: null,
            examResult: {
                ExamId:"",
                PaperTitle: "",
                ExamResult: "",
                ExamResultLink: "",                
            },
            errorMessage: ""

        }
    };
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        this.setState({ commonParamater: commonParamater, tenantId: tenantId });
        
        this.loadPage(tenantId, commonParamater);
    };
    loadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/SanQiHuYu/GetWrittenResult", { params: params })
            .then(res => {
                const code = res.data.code;
                
                if (code==="200") {
                    const data = res.data.code;
                    
                    var examResult = {};
                    examResult.ExamId = res.data.data.examId;
                    examResult.PaperTitle = res.data.data.paperTitle;
                    examResult.ExamResult = res.data.data.examResult;
                    examResult.ExamResultLink = res.data.data.examResultLink;

                    this.setState({ examResult: examResult, isReady: true });
                }
                else {
                    this.setState({ errorMessage: res.data.message, isReady: true });
                }              

            })
            .catch(reason => {
                this.setState({ errorMessage: "系统异常", isLoading: true });
            });
    };

    getResultLinkUrl = () => {
        var tenantId = this.state.tenantId;
        var examId = this.state.examResult.ExamId;
        const params = {
            tenantId,
            examId
        }
        axios
            .get("/api/SanQiHuYu/GetWrittenResultLink", { params: params })
            .then(res => {
                const code = res.data.code;

                if (code === "200") {
                    const data = res.data.code;
                    var examResultLink = res.data.data;

                    window.open(examResultLink);
                }
                else {
                    Modal.error({
                        title: '异常',
                        content: res.data.message,
                    });
                }

            })
            .catch(reason => {
                this.setState({ errorMessage: "系统异常", isLoading: true });
            });
    };

    render() {
        const style = { padding: '8px 0', textAlign: 'left' };
        
        var ExamResultLink = null;
      
        if (this.state.examResult.ExamResultLink !== "") {
            ExamResultLink = (<Button type="primary" onClick={this.getResultLinkUrl}>点击查看</Button>)
        } else {
            ExamResultLink = (<span>-</span>)
            
        }

        if (this.state.isReady) {
            if (this.state.examResult.PaperTitle === "无笔试" || this.state.examResult.PaperTitle === null) {
                return (
                    <div style={{ textAlign: "left", padding: "32px", marginTop: "-10%", marginLeft: "-10%" }}>
                        <span style={{ color: "red" }}>没有安排笔试</span>
                    </div>
                )
            }
            else {
                return (                     
                    <div style={{ textAlign: "left" }}>
                        <h2>笔试结果</h2>
                        <Row gutter={16}>
                            <Col className="gutter-row" span={6}>
                                <div style={style}>试卷名称</div>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <div style={style}>{this.state.examResult.PaperTitle}</div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col className="gutter-row" span={6}>
                                <div style={style}>笔试结果</div>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <div style={style}>{this.state.examResult.ExamResult}</div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col className="gutter-row" span={6}>
                                <div style={style}>结果链接</div>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <div style={style}>{ExamResultLink}</div>
                            </Col>
                        </Row>                        
                    </div>
                )
            }

        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}